const themes = ['monokai', 'tomorrow', 'kuroir', 'twilight', 'solarized_light'];
const fontSizes = [14, 16, 18, 20];

export {themes, fontSizes};
